import PropTypes from 'prop-types';
import React from 'react';

import NotImplemented from '../NotImplemented';
import ProductCompareUI from '../ProductCompare';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { getUrlParamName, useAppProps } from './utils';

const CompareProductsMap = ({ fields, rendering, ...rest }) => {
  const appName = useAppName();
  const urlParamName = getUrlParamName(appName);
  const appProps = useAppProps(appName, rendering?.componentName ?? '', fields);
  if (!appProps) {
    return <NotImplemented name="CompareProducts" />;
  }

  const {
    legalDisclaimer,
    sectionHeadingTitle,
    goBackButton,
    viewDetailsButton,
    selectProductsToCompare,
    productLine,
    productCatalogDataTree,
    isDownloadCtaValid,
    gtmTags,
    paymentOptions,
    variant,
    sellingPriceTooltipDiscalimerLabel,
    referenceCompareProducts,
  } = appProps;

  return (
    <ProductCompareUI
      productCatalogDataTree={productCatalogDataTree}
      productLine={productLine}
      legalDisclaimer={legalDisclaimer}
      sectionHeadingTitle={sectionHeadingTitle}
      goBackButton={goBackButton}
      viewDetailsButton={viewDetailsButton}
      selectProductsToCompare={selectProductsToCompare}
      sellingPriceTooltipDiscalimerLabel={sellingPriceTooltipDiscalimerLabel}
      paymentOptions={paymentOptions}
      urlParamName={urlParamName}
      isDownloadCtaValid={isDownloadCtaValid}
      {...rest}
      gtmTags={gtmTags}
      variant={variant}
      referenceCompareProducts={referenceCompareProducts}
    />
  );
};

CompareProductsMap.propTypes = {
  fields: PropTypes.shape({}),
  rendering: PropTypes.shape({
    componentName: PropTypes.string,
  }),
};

export default CompareProductsMap;
